import Immutable from 'immutable'
import moment from 'moment'

import createProductOption from './ProductOption'
import createProductRequirement from './ProductRequirement'

export const ProductRecord = Immutable.Record({
  addressRequired: null,
  defaultContract: null,
  defaultPeriod: null,
  defaultSla: null,
  defaultSpeed: null,
  displayOrder: null,
  features: Immutable.OrderedSet(),
  id: null,
  name: '',
  options: Immutable.OrderedSet(),
  primary: false,
  requirements: Immutable.OrderedSet(),
  speeds: Immutable.OrderedSet(),
  supplier: '',
  supplierIdFields: Immutable.OrderedSet(),
  supplierName: '',
  type: '',
}, 'Product')

export default function createProduct({
  defaultContract,
  defaultPeriod,
  defaultSla,
  features = [],
  options = [],
  requirements = [],
  speeds = [],
  supplierIdFields = [],
  ...data
}) {
  return new ProductRecord({
    ...data,
    defaultContract: defaultContract ? moment.duration(defaultContract) : null,
    defaultPeriod: defaultPeriod ? moment.duration(defaultPeriod) : null,
    defaultSla: defaultSla ? moment.duration(defaultSla) : null,
    features: Immutable.OrderedSet(features),
    options: Immutable.OrderedSet(options).map(o => createProductOption(o)),
    requirements: Immutable.OrderedSet(requirements).map(r => createProductRequirement(r)),
    speeds: Immutable.OrderedSet(speeds),
    supplierIdFields: Immutable.OrderedSet(supplierIdFields),
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Product.js